// import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import { t } from "i18next";
// import { setMobileButttonBackColor } from "../utility";

// // Fix for default marker icons in Leaflet
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//     iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//     iconUrl: require('leaflet/dist/images/marker-icon.png'),
//     shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

// const VenueToLocationMap = ({ venueLocation, selectedLocation }) => {
//     if (!venueLocation || !selectedLocation) return null;

//     const venuePos = [venueLocation.lat, venueLocation.lng];
//     const selectedPos = [selectedLocation.latitude, selectedLocation.longitude];

//     // Line coordinates between the two points
//     const lineCoordinates = [venuePos, selectedPos];

//     return (
//         <div style={{ height: '200px', width: '100%', marginTop: '16px', borderRadius: '8px', overflow: 'hidden' }}>
//             <MapContainer
//                 center={venuePos}
//                 zoom={13}
//                 style={{ height: '100%', width: '100%' }}
//                 zoomControl={true}
//                 dragging={true}
//                 touchZoom={true}
//                 scrollWheelZoom={true}
//                 doubleClickZoom={true}
//                 boxZoom={true}
//             >
//                 <TileLayer
//                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                     attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//                 />
//                 <Marker position={venuePos}>
//                     <Popup>{t("Venue Location")}</Popup>
//                 </Marker>
//                 <Marker position={selectedPos}>
//                     <Popup>{t("Delivery Location")}</Popup>
//                 </Marker>
//                 <Polyline
//                     positions={lineCoordinates}
//                     color={setMobileButttonBackColor()}
//                     weight={3}
//                     dashArray="5, 5"
//                 />
//             </MapContainer>
//         </div>
//     );
// };


// export default VenueToLocationMap;


import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { t } from "i18next";
import { setMobileButttonBackColor } from "../utility";
import { useEffect, useRef } from 'react';

// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const VenueToLocationMap = ({ venueLocation, selectedLocation }) => {
    const mapRef = useRef();

    useEffect(() => {
        if (mapRef.current && venueLocation && selectedLocation) {
            const venuePos = [venueLocation.lat, venueLocation.lng];
            const selectedPos = [selectedLocation.latitude, selectedLocation.longitude];
            const bounds = L.latLngBounds([venuePos, selectedPos]);
            mapRef.current.fitBounds(bounds, { padding: [50, 50] });
        }
    }, [venueLocation, selectedLocation]);

    if (!venueLocation || !selectedLocation) return null;

    const venuePos = [venueLocation.lat, venueLocation.lng];
    const selectedPos = [selectedLocation.latitude, selectedLocation.longitude];
    const lineCoordinates = [venuePos, selectedPos];

    return (
        <div style={{ height: '200px', width: '100%', marginTop: '16px', borderRadius: '8px', overflow: 'hidden' }}>
            <MapContainer
                center={venuePos}
                zoom={13}
                style={{ height: '100%', width: '100%' }}
                whenCreated={(map) => { mapRef.current = map; }}
                ref={mapRef}
                zoomControl={false}
                dragging={false}
                touchZoom={false}
                doubleClickZoom={false}
                scrollWheelZoom={false}
                boxZoom={false}
                keyboard={false}
                tap={false}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker position={venuePos}>
                    <Popup>{t("Venue Location")}</Popup>
                </Marker>
                <Marker position={selectedPos}>
                    <Popup>{t("Delivery Location")}</Popup>
                </Marker>
                <Polyline
                    positions={lineCoordinates}
                    color={setMobileButttonBackColor()}
                    weight={3}
                    dashArray="5, 5"
                />
            </MapContainer>
        </div>
    );
};

export default VenueToLocationMap;